export default "/images/76f246e9cc9c3abf24571b40c2f26da9.png";